var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonePe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1969_24144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 30.8353C35 33.137 33.135 35.002 30.8333 35.002H9.16667C6.86583 35.002 5 33.137 5 30.8353V9.16862C5 6.86695 6.86583 5.00195 9.16667 5.00195H30.8333C33.135 5.00195 35 6.86695 35 9.16862V30.8353Z",
    fill: "#4527A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8885 16.8109C26.8885 16.2434 26.4019 15.7576 25.8352 15.7576H23.8902L19.4319 10.5492C19.0269 10.0626 18.3785 9.90089 17.7294 10.0626L16.1894 10.5492C15.946 10.6301 15.8652 10.9542 16.0269 11.1167L20.8902 15.8384H13.5144C13.271 15.8384 13.1094 16.0009 13.1094 16.2434V17.0542C13.1094 17.6217 13.596 18.3092 14.1627 18.3092H15.806V21.8967C15.806 24.8151 17.1485 26.5167 19.7419 26.5167C20.5527 26.5167 20.8902 26.4359 21.7002 26.1117V28.7051C21.7002 29.4342 22.2677 30.0017 22.9969 30.0017H23.6519C23.8952 30.0017 24.1385 29.7584 24.1385 29.5151V18.3092H26.4819C26.7252 18.3092 26.8869 18.1467 26.8869 17.9042V16.8109H26.8885ZM21.7019 23.6792C21.2152 23.9226 20.5669 24.0034 20.081 24.0034C18.7844 24.0034 18.3335 23.3551 18.3335 21.8959V18.3084H21.7027V23.6792H21.7019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1969_24144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0001,
    height: 40,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePe);
export default __webpack_public_path__ + "static/media/PhonePe.56e417dfae6a4314e3b589cd0017ddfa.svg";
export { ForwardRef as ReactComponent };